module.exports = __webpack_public_path__ + "static/media/Moderators.8421f792.md";